import { z } from "zod";

type DateOrderMessages = {
	startBeforeSigned: string;
	endBeforeSigned: string;
	endBeforeStart: string;
	fixationEndBeforeStart?: string;
};

type DateTrio = {
	signedAt: string | null;
	startAt: string | null;
	endAt: string | null;
	fixationEndDate?: string | null;
};

export const refineDateOrder =
	(
		messages: DateOrderMessages,
		fixationEndPath: (string | number)[] = ["fixationEndDate"],
	) =>
	(data: DateTrio, ctx: z.RefinementCtx): void => {
		const { signedAt, startAt, endAt, fixationEndDate } = data;

		if (signedAt && startAt && startAt < signedAt) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				path: ["startAt"],
				message: messages.startBeforeSigned,
			});
		}
		if (signedAt && endAt && endAt < signedAt) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				path: ["endAt"],
				message: messages.endBeforeSigned,
			});
		}
		if (startAt && endAt && endAt < startAt) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				path: ["endAt"],
				message: messages.endBeforeStart,
			});
		}
		if (
			messages.fixationEndBeforeStart &&
			startAt &&
			fixationEndDate &&
			fixationEndDate < startAt
		) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				path: fixationEndPath,
				message: messages.fixationEndBeforeStart,
			});
		}
	};
